import React from 'react';
import { motion } from 'framer-motion';

const LoadingScreen = () => {
  return (
    <motion.div 
      className="loading-screen"
      // 1. Initial State Background
      initial={{ opacity: 1 }}
      
      // 3. ANIMASI KELUAR (EXIT) - BACKGROUND
      // Background akan menghilang SETELAH teks selesai menghilang
      exit={{ 
        opacity: 0,
        transition: { 
          duration: 0.8, 
          delay: 0.6, // Menunggu teks hilang (0.5s) baru background mulai pudar
          ease: "easeInOut"
        } 
      }}
      
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh', 
        backgroundColor: '#000', 
        color: '#fff',
        position: 'fixed', // Pastikan menutupi layar
        inset: 0,
        zIndex: 99999
      }}
    >
      <div className="loader-content">
        <motion.h1
          // 2. ANIMASI MASUK & CAHAYA BERGERAK
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ 
            opacity: 1, 
            scale: 1,
            // Cahaya bergerak dari Kiri-Atas (-150%) ke Kanan-Bawah (200%)
            backgroundPosition: ["-150% -150%", "200% 200%"] 
          }}
          
          // Konfigurasi Durasi Cahaya
          transition={{ 
            opacity: { duration: 0.5 },
            scale: { duration: 0.5 },
            backgroundPosition: {
              duration: 5, // DURASI 5 DETIK
              ease: "linear", // Gerakan konstan
              repeat: 0, // HANYA SEKALI LEWAT (Tidak looping)
            }
          }}

          // 3. ANIMASI KELUAR (EXIT) - TEKS
          // Teks menghilang duluan
          exit={{ 
            opacity: 0, 
            scale: 0.95, 
            transition: { 
              duration: 0.5, 
              ease: "easeInOut" 
            } 
          }}

          style={{
            fontSize: '5rem', 
            fontWeight: '900', 
            letterSpacing: '10px',
            
            // LOGIKA CAHAYA (SHINE EFFECT)
            backgroundImage: `linear-gradient(
              135deg, 
              #333 40%, 
              #fff 50%, 
              #333 60%
            )`,
            
            backgroundSize: '250% 250%', 
            WebkitBackgroundClip: 'text', 
            WebkitTextFillColor: 'transparent', 
            backgroundClip: 'text',
            color: 'transparent',
            margin: 0,
            cursor: 'default'
          }}
        >
          VIX1ON
        </motion.h1>
      </div>
    </motion.div>
  );
};

export default LoadingScreen;